import React, { useEffect } from "react"
import BackgroundImage from "../components/background-images"
import SEO from "../components/seo"
import { useTranslation } from "react-i18next"
import Footer from "../components/footer"
import Header from "../components/header"
import cover from "../images/Cover.png"

import "../components/design.scss"
import { Button } from "react-bootstrap"
const IndexPage = () => {
  const { t, i18n } = useTranslation()

  return (
    <BackgroundImage>
      <SEO />

      <Header />
      <div
        className="container-fluid"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: "100%",
        }}
      >
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            paddingTop: 70,
          }}
        >
          <h2 style={{ textTransform: "uppercase" }}>
            {t("Do New Things.")}
            <br />
            {t("Meet New People.")}
          </h2>
          <h3 style={{ fontWeight: "lighter" }}>
            {t("Sign up to the newsletter and get your first 3 FOLOs free")}
          </h3>
          <Button
            id="newsletter-btn"
            variant="primary"
            onClick={() => {
              const script = document.createElement("script")
              script.id = "mcjs"
              script.src =
                "https://chimpstatic.com/mcjs-connected/js/users/64cc08a2ff39ecf1cb642cf82/2b197a8785b22c641dc5c1949.js"
              script.async = true

              document.body.appendChild(script)

              //Deletes Cookies
              document.cookie =
                "MCPopupClosed=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;"
              document.cookie =
                "MCPopupSubscribed=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;"
            }}
          >
            {t("Subscribe Newsletter")}
          </Button>
        </div>
        <img src={cover} style={{ marginBottom: -0 }} id="home-image" />
      </div>

      <Footer />
    </BackgroundImage>
  )
}

export default IndexPage
